/* eslint-disable no-undef */
import styles from '../setup/map-styles.json';

export default function Map() {
  // Init namespace constants
  self.locations, self.activeView, self.selected,
  self.zoom = 0, self.styles, self.mapObject,
  self.bootSteps = 0,
  self.mapMarker = {
    rest: '/wp-content/themes/aptim/public/images/map_marker.png',
    hover: '/wp-content/themes/aptim/public/images/map_marker_hover.png',
  },
  self.markerList = []

  //Namespace methods
  self.bootstrap = () => {
    $(document).ready(() => {
      //Retrieve location data
      $.ajax({ url: '/wp-json/api/v1/locations' })
        .done((response) => {
          // Process and format recieved data and store for later use in namespace
          self.locations = response
          // Notify step completion and pass relevant data, if any
          self.notify.locations.complete()
        })

      self.styles = styles
      self.notify.mapStyles.complete()
    })
  }

  self.init = () => {
    // if all 3 bootSteps were notified (location and style JSON retreived, GMaps lib has finished loading and flagged our callback to let us know), proceed
    if (self.bootSteps < 3) return;

    //Flag passed. full steam ahead!
    self.setupMap()
    self.setupEvtListeners()
    self.afterSetup()
  }

  self.notify = {
    locations: {
      complete: function () {
        /**
         * Now that locations are loaded, evaluate
         * if url contains a location to start on
         **/
        let rval
        let hash = location.hash.substr(1)
        const defaultLocation = Object.values(self.locations).find((location) => location.is_default);

        switch (true) {
          //Match UID to key in self.locations
          case (hash in self.locations):
            rval = hash
            break
          default:
            rval = defaultLocation?.uid || Object.keys(self.locations)[0]
        }

        //Set hash/default location as location
        self.setLocation(rval)

        //Step completed, log and attempt to run
        self.bootSteps++

        self.init()
      },
    },
    mapStyles: {
      complete: function () {
        //Step completed, log and attempt to run
        self.bootSteps++

        self.init()
      },
    },
    mapLib: {
      complete: function () {
        //Step completed, log and attempt to run
        self.bootSteps++

        self.init()
      },
    },
  }

  self.afterSetup = () => {
    //Set selected location's associated DOM element to be active
    self.assignSelectedLocation()

    //Check if a location is anchored to in URL
    if (location.hash) {
      //Scroll down to map section
      $('html, body').animate({
        scrollTop: $('.map-locations').offset().top,
      }, 1500)
    }
  }

  self.assignSelectedLocation = () => {
    const data = $('.location-data [data-uid="' + self.selected.uid + '"]')
    let thumbnail = data.find('[data-attribute="thumbnail"]').text().trim()
    let address = data.find('[data-attribute="address"]').html().trim()
    let phone = data.find('[data-attribute="phone"]').text().trim()
    let lat = data.find('[data-attribute="lat"]').text().trim()
    let lng = data.find('[data-attribute="lng"]').text().trim()
    let permalink = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
    let location = $('.single-location')
    if (!thumbnail.length) {
      thumbnail = '/app/themes/aptim/dist/images/no-image.png'
    }
    location.find('[data-attribute="thumbnail"]').css({ 'background-image': 'url(' + thumbnail + ')' });
    location.find('[data-attribute="address"]').html(address)
    if (phone) {
      location.find('[data-attribute="phone"]').attr('href', 'tel:' + phone)
      location.find('[data-attribute="phone"]').text(phone)
    }
    location.find('[data-attribute="permalink"]').attr('href', permalink)

    if ($('.single-location').is(':hidden')) {
      $('.single-location').show()
    }
  }

  self.redrawMap = () => {
    //Update all marker icons
    for (let i = 0; i < self.markerList.length; i++) {
      self.markerList[i].setIcon((self.markerList[i].uid == self.selected.uid ? self.mapMarker.hover : self.mapMarker.rest))
    }
  }

  self.setLocation = (uid) => {
    self.selected = self.locations[uid]
  }

  self.setupEvtListeners = () => {
    $('.map-locations .btn-view').on('click', (event) => {
      let self = window.APTIM.Map

      self.activeView = $(event.currentTarget).attr('data-active')

      // Show currently selected map view
      $('.map-locations .content-area > .active').removeClass('active')
      $('.map-locations .content-area #' + self.activeView).addClass('active')

      // Change toggle to reflect active map view in DOM (map|list)
      $('.btn-view.active').removeClass('active')
      $(event.currentTarget).addClass('active')
    })

    $('.maplist li').on('click', (event) => {
      let self = window.APTIM.Map

      //Change location in namespace object
      self.setLocation($(event.currentTarget).attr('data-uid'))

      // Update map to reflect changes
      self.redrawMap()

      // Set selected location
      self.assignSelectedLocation()
    })
  }

  self.setupMap = () => {
    self.mapObject = new google.maps.Map($('#map')[0], {
      zoom: 4,
      center: {
        lat: self.selected.lat,
        lng: self.selected.lng,
      },
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: false,
      styles: self.styles,
    })

    //Loop through locations and do that GMaps magic
    for (let loc in self.locations) {
      //Add marker to Google Map for each location
      let marker = new google.maps.Marker({
        position: new google.maps.LatLng(self.locations[loc].lat, self.locations[loc].lng),
        map: self.mapObject,
        icon: (loc === self.selected.uid) ? self.mapMarker.hover : self.mapMarker.rest,
        uid: loc,
      })

      //Store marker for later usage
      self.markerList.push(marker)

      //Add click listener
      marker.addListener('click', function () {
        let self = window.APTIM.Map

        // Set location as selected
        self.setLocation(this.uid)

        // Redraw map to show new updates
        self.redrawMap()

        // Set selected location
        self.assignSelectedLocation()
      })
    }
  }

  // Bombs Away!
  self.bootstrap()

  return self
}
